import {useEffect, useState} from 'react';
import {Button, Table, Divider, Col, Row} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import {
  PageSizeArray,
  PaginationPosition,
  eventRefundsFilters,
  formatCurrencyByLocalChapter,
  formatDate,
  selectRowsWithSponsorVendorReps,
} from '../../../Util/commonUtility';
import {FilterOutlined} from '@ant-design/icons';
import DynamicSearchForm from '../../CommonComponents/DynamicSearch';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import {useNavigate} from 'react-router-dom';
import {getAllChapters} from '../../../Store/Actions';
import {DescriptionItem} from './../../../Util/commonUtility';
import AdminViewDetailsDrawer from './../../CommonComponents/AdminViewDetailsDrawer/index';
import {usePermissions} from '../../../hooks/usePermission';
import useLocalization from '../../../Localization';
import useRefundApproval from '../../CommonComponents/RefundApproval/useRefundApproval';
import RefundApprovalFooter from '../../CommonComponents/RefundApproval/RefundApprovalFooter';

const EventRefundComponent = (props) => {
  let dispatch = useDispatch();
  const {
    allEventRefundData,
    paging,
    sortParams,
    handleTableChange,
    handlePaginationChange,
    fetchEventRefunds,
    searchValues,
    eventLocalChapterId,
  } = props;
  const [expanded, setExpanded] = useState(false);
  const [selectionType, setSelectionType] = useState('checkbox');
  const [isRefundAccessed, setIsRefundAccessed] = useState(true);

  const [open, setOpen] = useState(false);
  const [openDrawerDetails, setOpenDrawerDetails] = useState(false);
  const navigate = useNavigate();
  const {ApplicationString} = useLocalization();

  const {
    showApproveReject,
    isModalVisible,
    refundToAccount,
    setRefundToAccount,
    percentageRefund,
    refundMode,
    exactAmountRefund,
    selectedRowTotalRefundAmount,
    selectedRowCreditAmount,
    selectedRowPaidAmount,
    selectedRowPaidAmountWithFee,
    selectedRowStripePaymentIds,
    selectedRowTotalDiscount,
    isCreditOnlyRefund,
    selectedRowKeys,
    rowSelection,
    handleRadioChange,
    handleRefundVisible,
    handleCancelRefund,
    hideModal,
    handleApproveRefunds,
    refundSubmitting,
    selectedRowProcessingFee,
    selectedRowProcessingFeePercentage,
    handleInputChange,
    handleRefundAmountChange,
    handleRefundModeChange,
  } = useRefundApproval();

  const allChapters = useSelector((state) => state.chapters.allChapters);
  const localChapterData = allChapters?.data?.chapters?.find(
    (obj) => obj.id === eventLocalChapterId,
  );
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const userRole = userInfo?.role;
  const {checkPermission} = usePermissions(userRole);

  useEffect(() => {
    if (!checkPermission('events_refund', 'refundRegistration')) {
      setIsRefundAccessed(false);
    }
  }, []);
  useEffect(() => {
    if (!localChapterData) {
      dispatch(getAllChapters());
    }
  }, [localChapterData]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    searchValues && setExpanded(true);
  }, [searchValues]);

  // Drawer functions ----------------------------------------------------
  const showDrawer = (record) => {
    setOpenDrawerDetails(record);
    setOpen(true);
  };

  const onCloseDrawer = () => {
    setOpen(false);
  };

  const EventDrawerContent = () => {
    const {
      attendee_first_name,
      attendee_last_name,
      user_id,
      event_id,
      attendee_email,
      attendee_company,
      is_sponsor,
      is_reps,
      registration_type,
      event_registration_options,
      total_cost,
      discount_amount,
      discount_code,
      status,
      created_at,
      credit_amount,
      is_processing_fee_added,
      processing_fee_percentage,
      processing_fee_amount,
      refunded_amount,
      refund_to_account,
      transaction_id,
    } = openDrawerDetails || {};

    return (
      <>
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Attendee Status'
              content={
                {
                  3: 'Paid',
                  4: 'Payment Confirmed',
                  6: 'Fee Wavier',
                  '-1': 'To be Deleted',
                  0: 'Payment Refunded',
                  1: 'To be Paid',
                  2: 'Refund Pending',
                  5: 'No Charge Event',
                }[status] || status
              }
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem title='User Id' content={user_id} />
          </Col>
          <Col span={12}>
            <DescriptionItem title='Event Id' content={event_id} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem title='First Name' content={attendee_first_name} />
          </Col>
          <Col span={12}>
            <DescriptionItem title='Last Name' content={attendee_last_name} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem title='Attendee Email' content={attendee_email} />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Attendee Company'
              content={attendee_company}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Sponsorship'
              content={is_sponsor ? 'Yes' : 'No'}
            />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Representative'
              content={is_reps ? 'Yes' : 'No'}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Registration Type'
              content={registration_type}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Registration Option'
              content={
                event_registration_options?.sponsorship?.name
                  ? event_registration_options?.sponsorship?.name
                  : event_registration_options?.registration?.name +
                    ' ' +
                    '-' +
                    ' ' +
                    formatCurrencyByLocalChapter(
                      event_registration_options?.registration?.price,
                      localChapterData,
                    )
              }
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Food Option'
              content={
                event_registration_options?.food?.name
                  ? event_registration_options?.food?.name +
                    ' ' +
                    '-' +
                    ' ' +
                    formatCurrencyByLocalChapter(
                      event_registration_options?.food?.price,
                      localChapterData,
                    )
                  : 'No Food'
              }
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Total Cost'
              content={formatCurrencyByLocalChapter(
                total_cost ? total_cost : 0,
                localChapterData,
              )}
            />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Used Credit'
              content={formatCurrencyByLocalChapter(
                credit_amount ? credit_amount : 0,
                localChapterData,
              )}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Discounted Cost'
              content={formatCurrencyByLocalChapter(
                discount_amount ? discount_amount : 0,
                localChapterData,
              )}
            />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Total Cost After Discount'
              content={formatCurrencyByLocalChapter(
                total_cost - discount_amount || 0,
                localChapterData,
              )}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Coupon Code Applied'
              content={discount_code || 'N/A'}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Registered Date'
              content={formatDate(created_at)}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Processing Fee Added'
              content={
                is_processing_fee_added
                  ? 'Yes (paid by attendee)'
                  : 'No (absorbed by org)'
              }
            />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Processing Fee Amount'
              content={`${formatCurrencyByLocalChapter(
                processing_fee_amount ? processing_fee_amount : 0,
                localChapterData,
                2,
                2,
              )}${
                processing_fee_percentage
                  ? ` (${processing_fee_percentage}%)`
                  : ''
              }`}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={12}>
            <DescriptionItem
              title='Refunded Amount'
              content={formatCurrencyByLocalChapter(
                refunded_amount ? refunded_amount : 0,
                localChapterData,
                2,
                2,
              )}
            />
          </Col>
          <Col span={12}>
            <DescriptionItem
              title='Refund Method'
              content={
                Number(refunded_amount) > 0
                  ? refund_to_account
                    ? 'Refund in PBSS Credit'
                    : 'Refund in Bank Account'
                  : 'N/A'
              }
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={24}>
            <DescriptionItem
              title='Stripe Payment ID'
              content={transaction_id || 'N/A'}
            />
          </Col>
        </Row>
        <Divider />
      </>
    );
  };

  const toggleExpand = () => {
    setExpanded(!expanded);
  };
  const handleSearch = (values) => {
    fetchEventRefunds(values);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      sorter: true,
      width: '4%',
    },
    {
      title: 'First Name',
      dataIndex: 'attendee_first_name',
      sorter: true,
      width: '10%',
      render: (text) => {
        return <span>{text || 'N/A'}</span>;
      },
    },
    {
      title: 'Last Name',
      dataIndex: 'attendee_last_name',
      sorter: true,
      width: '10%',
      render: (text) => {
        return <span>{text || 'N/A'}</span>;
      },
    },
    {
      title: 'Email',
      dataIndex: 'attendee_email',
      sorter: true,
      width: '15%',
      ellipsis: true,
      render: (text) => {
        return <span>{text || 'N/A'}</span>;
      },
    },
    {
      title: 'Type',
      key: 'registration_type_label',
      width: '8%',
      render: (_, record) => {
        if (record?.is_sponsor) return <span>Sponsor</span>;
        if (record?.is_reps) return <span>Vendor rep</span>;
        return <span>Attendee</span>;
      },
    },
    {
      title: 'Registration Option',
      dataIndex: 'registration_option',
      width: '15%',
      render: (text, record) => {
        const isOptionsSponsor =
          record.event_registration_options?.sponsorship?.name;
        return (
          <span>
            {/* {checkIsEditable(record)} */}
            {record?.is_reps || record?.is_sponsor
              ? 'N/A'
              : isOptionsSponsor
              ? isOptionsSponsor
              : record.event_registration_options?.registration?.name +
                ' ' +
                '-' +
                ' ' +
                formatCurrencyByLocalChapter(
                  record?.event_registration_options?.registration?.price,
                  localChapterData,
                )}
          </span>
        );
      },
    },
    {
      title: 'Food Option',
      dataIndex: 'food',
      width: '15%',
      ellipsis: true,
      render: (text, record) => {
        return (
          <span>
            {record.event_registration_options?.food?.name
              ? record.event_registration_options?.food?.name +
                ' ' +
                '-' +
                ' ' +
                formatCurrencyByLocalChapter(
                  record?.event_registration_options?.food?.price,
                  localChapterData,
                )
              : 'No Food'}
          </span>
        );
      },
    },
    {
      title: 'Total Cost',
      dataIndex: 'total_cost',
      width: '10%',
      ellipsis: true,
      sorter: true,
      render: (text) => {
        return (
          <span>
            {formatCurrencyByLocalChapter(text ? text : 0, localChapterData)}
          </span>
        );
      },
    },
    {
      title: 'Refund Amount',
      dataIndex: 'refunded_amount',
      width: '10%',
      ellipsis: true,
      sorter: true,
      render: (text) => {
        return (
          <span>{formatCurrencyByLocalChapter(text, localChapterData)}</span>
        );
      },
    },
    {
      title: 'Refund Mode',
      dataIndex: 'refund_to_account',
      width: '10%',
      ellipsis: true,
      sorter: true,
      render: (text, record) => {
        let refundMode;
        //Added specific condition for true and false because initially show NA when refund is approved the show Direct or Credit
        if (record?.status === 'Refund Pending') {
          refundMode = 'N/A';
        } else {
          refundMode = text ? 'Credit' : 'Direct';
        }
        return <span>{refundMode}</span>;
      },
    },
    {
      title: 'Stripe Payment ID',
      dataIndex: 'transaction_id',
      width: '14%',
      ellipsis: true,
      render: (text) => <span>{text || 'N/A'}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      fixed: 'right',
      width: '9%',
      render: (text) => {
        return <span>{text}</span>;
      },
    },
    {
      title: '',
      key: 'action',
      fixed: 'right',
      width: '3%',
      render: (_, record) => (
        <AdminActionsDropdown
          text='Event Refund'
          record={record}
          viewBool={true}
          handleView={showDrawer}
          resource='events_refund'
          localChapterData={localChapterData}
        />
      ),
    },
  ];
  columns.forEach((column) => {
    if (column.key !== 'action') {
      column.sortOrder =
        sortParams.field === column.dataIndex && sortParams.order;
    }
  });

  return (
    <div className='main-container'>
      <AdminViewDetailsDrawer
        content={EventDrawerContent}
        visible={open}
        text={'Event Refund'}
        onCloseDrawer={onCloseDrawer}
        isEditable={false}
      />
      <div className='search-container' style={{gap: '10px'}}>
        <Button
          onClick={() => navigate('/admin/events')}
          id='EventRefundComponent-button-backToEvent'>
          Back To Events
        </Button>
        <Button onClick={toggleExpand} id='EventRefund-button-filterSearch'>
          {expanded ? <FilterOutlined /> : <FilterOutlined />}{' '}
          {ApplicationString['dynamicSearch.button.heading']}
        </Button>
      </div>
      {expanded && (
        <DynamicSearchForm
          columns={eventRefundsFilters}
          onSearch={handleSearch}
          savedFilteredValues={searchValues}
          title={'event_refunds'}
        />
      )}
      <div className='listing-container'>
        <Table
          bordered
          className='admin-table'
          columns={columns}
          dataSource={allEventRefundData}
          rowKey={'id'}
          onChange={handleTableChange}
          sticky={true}
          rowSelection={
            isRefundAccessed
              ? {
                  type: selectionType,
                  ...rowSelection,
                  onChange: (_selectedRowIds, selectedRows) => {
                    const cannotRefund = (row) =>
                      row?.status === 'Payment Refunded' ||
                      row?.status === 'To be Paid';
                    const rows = selectRowsWithSponsorVendorReps(
                      selectedRowKeys,
                      selectedRows,
                      allEventRefundData,
                      cannotRefund,
                    );
                    rowSelection.onChange(_selectedRowIds, rows);
                  },
                  getCheckboxProps: (record) => {
                    const base = rowSelection.getCheckboxProps(record);
                    return {
                      ...base,
                      disabled:
                        base.disabled ||
                        record?.status === 'To be Paid',
                    };
                  },
                }
              : undefined
          }
          footer={() => (
            <div>
              <RefundApprovalFooter
                showApproveReject={showApproveReject}
                isModalVisible={isModalVisible}
                hideModal={hideModal}
                refundSubmitting={refundSubmitting}
                handleRadioChange={handleRadioChange}
                refundToAccount={refundToAccount}
                setRefundToAccount={setRefundToAccount}
                handleInputChange={handleInputChange}
                percentageRefund={percentageRefund}
                refundMode={refundMode}
                handleRefundModeChange={handleRefundModeChange}
                selectedRowProcessingFee={selectedRowProcessingFee}
                selectedRowProcessingFeePercentage={
                  selectedRowProcessingFeePercentage
                }
                exactAmountRefund={exactAmountRefund}
                handleRefundAmountChange={handleRefundAmountChange}
                handleApproveRefunds={handleApproveRefunds}
                selectedRowTotalRefundAmount={selectedRowTotalRefundAmount}
                selectedRowCreditAmount={selectedRowCreditAmount}
                selectedRowPaidAmount={selectedRowPaidAmount}
                selectedRowPaidAmountWithFee={selectedRowPaidAmountWithFee}
                selectedRowStripePaymentIds={selectedRowStripePaymentIds}
                selectedRowTotalDiscount={selectedRowTotalDiscount}
                localChapterData={localChapterData}
                handleRefundVisible={handleRefundVisible}
                handleCancelRefund={handleCancelRefund}
                creditOnlyRefund={isCreditOnlyRefund}
              />
            </div>
          )}
          pagination={{
            onChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            current: paging.page,
            total: paging.totalCount,
            pageSize: paging.pageCount,
            pageSizeOptions: PageSizeArray,
            showSizeChanger: true,
            showQuickJumper: true,
            onShowSizeChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            showTotal: (total, range) => `Total ${total} items`,
            position: [PaginationPosition],
          }}
        />
      </div>
    </div>
  );
};

export default EventRefundComponent;
